export default __webpack_public_path__ + "static/media/newprofileimage.15cac823.svg";